"use client";
import { sendPv as sendPvHome } from "@/tracks/25223";
import { sendPv } from "@/tracks/Activity";
import { useEffect } from "react";
export default function PvModule({ pageCode, seo }: any) {
  const trackingId = seo.pageTrackingId ? seo.pageTrackingId : "";
  // ---------- 获取cms配置活动的pageName来作为兜底埋点id ----------- //
  const getDefaultTrackingId = () => {
    const url = new URL(window.location.href);
    const path = url.pathname;
    const cmsIndex = path.indexOf("cms/");
    return cmsIndex > -1 ? path.substring(cmsIndex + 4) : "";
  };

  // ---------------- 上报埋点 ---------------- //
  useEffect(() => {
    if (pageCode === "home") {
      sendPvHome.Home_Main();
      return;
    }
    if (trackingId) {
      sendPv.Activity(trackingId);
    } else {
      const defaultTracking = getDefaultTrackingId();
      sendPv.Activity(`cms_${defaultTracking}`);
    }
  }, [pageCode]);
  return null;
}
